import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "components/common";
import { MessageFieldsEditModal } from "components/common/message/details";
const EditFavoriteFieldsAction = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation("enterprise_search");
  const toggleEditMode = useCallback(() => setIsOpen((cur) => !cur), []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconButton, { name: "edit", title: t("edit_favorite_fields_action.title"), onClick: toggleEditMode }), isOpen && /* @__PURE__ */ React.createElement(MessageFieldsEditModal, { toggleEditMode }));
};
export default EditFavoriteFieldsAction;
